<template>
  <div class="empty-list">
    <div class="text">
      No questions for this lecture
    </div>
    <div class="action-btn">
      <ButtonArrow
        text="Ask a question" type="div"
        class="button-arrow accent"
        @click="ask"
      />
    </div>
  </div>
</template>

<script>
import ButtonArrow from '../components/ButtonArrow';

export default {
  name: 'EmptyList',
  components: {
    ButtonArrow,
  },
  methods: {
    ask() {
      if (this.$config.project === 'site') {
        this.$router.push('/signup/');
      } else {
        this.$root.$emit('new-question');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.empty-list {
  .text {
    color: var(--main-dark-light-4);
    font-size: 18px;
    font-weight: 600;
    line-height: 23px;
  }

  .action-btn {
    margin-top: var(--spacing-16);
  }
}
</style>
